import dynamic from "next/dynamic";
import { GlobalModalContext } from "@directv-digital/dds.core.global-modal-context";
import React from "react";
import ErrorDisplay from "@directv-digital/dds.ui.error-display";

const DtvButtonModal = dynamic(
  () => import("@/video-lab/dtv-button-modal")
);

export const GlobalModal = ({ children }) => {
  try{
    const [buttonModalData, setButtonModalData] = React.useState<any>();
    const { modalType, modalData } = buttonModalData || {};
    const [openModal, setOpenModal] = React.useState(false);

    const showModal = (type: string, data: any = undefined) => {
      const isInline = data?.inline && data?.inlineAnchorId;
      // Only trigger modal open state for non-inline usage
      setOpenModal(!isInline);
      setButtonModalData({
        ...buttonModalData,
        modalType: type,
        modalData: data
      });
      if (!isInline) {
        setTimeout(() => {
          const eleId = data?.id;
          const ele = document.querySelector(`.legalModal #${eleId}`);
          if(ele) {
            ele.scrollIntoView();
          }
        }, 1000);
      }
    };

    const hideModal = () => {
      setOpenModal(false);
      setButtonModalData({
        ...buttonModalData,
        modalType: null,
        modalData: undefined
      });
    };

    const renderComponent = () => {
      try{
        if (!(modalType || modalData)) {
          return null;
        }

        const modalDataProps = {
          ...modalData,
          openModal,
          handleClose: hideModal
        };
        return <DtvButtonModal modalData={modalDataProps} modalType={modalType} />;
      } catch (error) {
        return <ErrorDisplay error={error}/>
      }
    };

    /* start-copilot */
    React.useEffect(() => {
      if (typeof window === "undefined") {
        return undefined;
      }
      const handleFusionOpenModal = (event: Event) => {
        try {
          const customEvent = event as CustomEvent<{ modalType?: string; modalData?: any }>;
          const incomingType = customEvent?.detail?.modalType;
          if (!incomingType) {
            return;
          }
          showModal(incomingType, customEvent.detail?.modalData);
        } catch (error) {
          console.error("Failed to handle fusion:open-modal event", error);
        }
      };

      // eslint-disable-next-line no-undef
      window.addEventListener("fusion:open-modal", handleFusionOpenModal as EventListener);
      // eslint-disable-next-line no-undef
      return () => window.removeEventListener("fusion:open-modal", handleFusionOpenModal as EventListener);
    }, []);
    /* end-copilot */

    return (
      <GlobalModalContext.Provider value={{
 showModal,
hideModal
}}>
        {renderComponent()}
        {children}
      </GlobalModalContext.Provider>
    );
  } catch (error) {
    return <ErrorDisplay component= "Global Modal" error={error}  />
  }
};
